import React, { useState } from 'react';
import $ from 'jquery';
import type { Bank } from '@/common/models/banks/bank';
import type { BankBranch } from '@/common/models/banks/bankBranch';
import BankModalView from '../../banks/bankModalView';

interface Props {
  bank: Bank | null;
  branch: BankBranch | null;
  errors: {
    bank_id?: string[];
    bank_branch_id?: string[];
  };
}

export default function BankView({
  bank: initialBank,
  branch: initialBranch,
  errors,
}: Props) {
  const [bank, setBank] = useState<Bank | null>(initialBank);
  const [branch, setBranch] = useState<BankBranch | null>(initialBranch);

  const onOk = () => {
    $('#bank_modal').modal('hide');
  };

  const onCancel = () => {
    setBank(null);
    setBranch(null);
    $('#bank_modal').modal('hide');
  };

  const hasError = () => {
    return (
      (errors.bank_id != null && errors.bank_id.length > 0) ||
      (errors.bank_branch_id != null && errors.bank_branch_id.length > 0)
    );
  };

  const renderError = () => {
    return hasError() ? (
      <span className="help-block text-danger">を選択してください</span>
    ) : null;
  };

  return (
    <div>
      <div
        className={hasError() ? 'form-group row has-error' : 'form-group row'}
      >
        <label className="col-sm-3 col-form-label">
          金融機関・支店 <span className="required-mark">＊</span>
        </label>
        <div className="col-sm-9">
          <div className="row">
            <div className="col-sm-8">
              {(bank ?? branch) && (
                <div>
                  {bank && <span className="mr-10">{bank.name}</span>}
                  {branch && <span className="mr-10">{branch.name}</span>}
                </div>
              )}
              <button
                type="button"
                className="btn btn-lg btn-flat btn-primary-outline-gray"
                data-toggle="modal"
                data-target="#bank_modal"
              >
                金融機関・支店を選択
              </button>
              {renderError()}
              <input
                value={bank ? bank.id : ''}
                type="hidden"
                name="user[bank_id]"
              />
              <input
                value={branch ? branch.id : ''}
                type="hidden"
                name="user[bank_branch_id]"
              />
            </div>
          </div>
        </div>
      </div>

      <BankModalView
        bank={bank}
        branch={branch}
        onChangeBank={selectedBank => setBank(selectedBank)}
        onChangeBranch={selectedBranch => setBranch(selectedBranch)}
        onOk={onOk}
        onCancel={onCancel}
      />
    </div>
  );
}
